/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import { GET } from '/client/src/api';

type PropsType = {
  eventId: string | number,
  eventScheduleId: string | number,
  checkInUpdated: boolean
};

const CheckInEventStats = ({ eventId, eventScheduleId, checkInUpdated }: PropsType): React.Element<'div'> => {
  const [isPending, setPending] = React.useState(true);
  const [tickets, setTickets] = React.useState([]);
  const [physicalTickets, setPhysicalTickets] = React.useState([]);
  const checkedQuantityTotal = React.useRef(0);
  const soldQuantityTotal = React.useRef(0);
  const physicalCheckedQuantityTotal = React.useRef(0);
  const physicalSoldQuantityTotal = React.useRef(0);

  const fetchData = async () => {
    try {
      const url = `/api/v1/1/statistics/events/${eventId}/ticket_checkin_status?event_schedule_id=${eventScheduleId}`;
      const urlPhysical = `/api/v1/1/statistics/events/${eventId}/physicalticket_checkin_status?event_schedule_id=${eventScheduleId}`;

      setPending(true);

      const { result } = await GET(url);
      const { result: resultPhysical } = await GET(urlPhysical);

      setTickets(result);
      setPhysicalTickets(resultPhysical);

      checkedQuantityTotal.current = 0;
      soldQuantityTotal.current = 0;
      physicalCheckedQuantityTotal.current = 0;
      physicalSoldQuantityTotal.current = 0;

      result.forEach((t: {}) => {
        checkedQuantityTotal.current += t.checked_quantity;
        soldQuantityTotal.current += t.sold_quantity;
      });

      resultPhysical.forEach((t: {}) => {
        physicalCheckedQuantityTotal.current += t.checked_quantity;
        physicalSoldQuantityTotal.current += t.sold_quantity;
      });

      setPending(false);
    } catch (e) {
      console.log(e);
      console.error('Cant get tickets');
      setPending(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [eventId, eventScheduleId, checkInUpdated]);


  return (
    <div className='checkin-stats-container'>
      {isPending && <div className='csspinner' />}
      <div className='checkin-stats-item-container'>
      <div>Attendee</div>
      <div>
        <div className="progress progress-blue">
          <div className="progress-bar"
            style={{ width: `${((checkedQuantityTotal.current / soldQuantityTotal.current) || 0) * 100}%` }}
          />
          <div className="progress-text">
            <div className="text-left">Total Attendees</div>
            <div className="text-right">{`${checkedQuantityTotal.current}/${soldQuantityTotal.current}`}</div>
          </div>
        </div>
        {
          tickets.map((t: any, i: number): any => (
            <div key={i} className="progress progress-green">
              <div className="progress-bar"
                style={{ width: `${((t.checked_quantity / t.sold_quantity) || 0) * 100}%` }}
              />
              <div className="progress-text">
                <div className="text-left">{t.name}</div>
                <div className="text-right">{`${t.checked_quantity}/${t.sold_quantity}`}</div>
              </div>
            </div>
          ))
        }
        </div>
      </div>
      {!!_.size(physicalTickets) &&
        <div className='checkin-stats-item-container'>
          <div>Physical Ticket</div>
          <div>
            {
              physicalTickets.map((t: any, i: number): any => (
                <div key={-i} className="progress progress-green">
                  <div className="progress-bar"
                    style={{ width: `${((checkedQuantityTotal / soldQuantityTotal) || 0) * 100}%` }}
                  />
                  <div className="progress-text">
                    <div className="text-left" data-bind="text:name" />
                    <div className="text-right">{`${t.checked_quantity}/${t.sold_quantity}`}</div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      }
    </div>
  );
};

export default CheckInEventStats;